import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useAdmin } from '../../context/AdminContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTag, faUtensils } from '@fortawesome/free-solid-svg-icons';
import AdminFormModal from '../shared/AdminFormModal';
import ActionConfirmationModal from '../shared/ActionConfirmationModal';

const EditCategoryModal = ({ show, onClose, category, onCategoryUpdated }) => {
  const [name, setName] = useState('');
  const [isWarningModalVisible, setIsWarningModalVisible] = useState(false);
  const { menus } = useAdmin();
  const categoryMenu = menus.find((menu) => menu.id === category?.menuId) || null;

  useEffect(() => {
    if (category) {
      setName(category.name);
    }
  }, [category]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsWarningModalVisible(true);
  };

  const confirmUpdate = async () => {
    setIsWarningModalVisible(false);
    await onCategoryUpdated({ ...category, name, menuId: category.menuId });
    onClose();
  };

  return (
    <>
      <AdminFormModal
        show={show}
        onClose={onClose}
        title="Kategoriyi Düzenle"
        subtitle="Kategori adını güncelleyin. Menü bağlantısı korunur."
        icon={faEdit}
        footer={(
          <>
            <div className="admin-modal-footer-secondary">
              <Button variant="secondary" onClick={onClose} className="modal-cancel-btn">
                İptal
              </Button>
            </div>
            <div className="admin-modal-footer-primary">
              <Button variant="primary" onClick={handleSubmit} className="modal-save-btn modal-save-btn-success">
                Güncelle
              </Button>
            </div>
          </>
        )}
      >
        <Form onSubmit={handleSubmit} className="admin-form-section">
          <div className="admin-form-block">
            <div className="admin-form-block-title">
              <FontAwesomeIcon icon={faTag} />
              Kategori Bilgisi
            </div>
            <div className="admin-form-grid admin-form-grid-single">
              <div className="admin-modal-field">
                <Form.Label>Kategori Adı</Form.Label>
                <Form.Control type="text" value={name} onChange={(event) => setName(event.target.value)} required className="form-input" />
              </div>
              {categoryMenu ? (
                <div className="admin-modal-field">
                  <Form.Label>
                    <FontAwesomeIcon icon={faUtensils} className="form-icon" />
                    Menü
                  </Form.Label>
                  <Form.Control type="text" value={categoryMenu.name} disabled className="form-input" />
                  <div className="admin-modal-helper">Kategori bu menü altında kalır.</div>
                </div>
              ) : null}
            </div>
          </div>
        </Form>
      </AdminFormModal>

      <ActionConfirmationModal
        show={isWarningModalVisible}
        onClose={() => setIsWarningModalVisible(false)}
        onConfirm={confirmUpdate}
        title="Kategoriyi Güncelle"
        message={`Kategori "${category?.name}" güncellensin mi?`}
        consequences={['Kategori adı ilgili yönetim listelerinde güncellenecek.']}
        confirmLabel="Güncelle"
        cancelLabel="Vazgeç"
        tone="warning"
      />
    </>
  );
};

export default EditCategoryModal;
